import { client } from '../../../hooks/Client';
import momentTitlesByPosition from './momentTitlesByPosition';
import { definitionCollection } from '../../../firebase/publicDefinitions';

const cache = new Map();

const chunk = (arr, size) => {
  const out = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

/**
 * Fetch a map of measure-moment Position → user-given Title for the given
 * research(es).
 *
 * Used by the effect & research chart data builders (Number / Scale / Matrix)
 * so x-axis labels can show the moment's real title alongside its position
 * (e.g. "Voormeting (1)") instead of a bare "Meetmoment 1".
 *
 * @param {string[]} researchIds - Research IDs to look up moments for.
 * @returns {Promise<Object<number, string>>} Map of Position → Title.
 */
const getMomentTitlesByPosition = async (researchIds) => {
  const ids = (researchIds || []).filter(Boolean);
  const key = JSON.stringify([...ids].sort());
  if (cache.has(key)) return cache.get(key);
  if (!ids.length) {
    cache.set(key, {});
    return {};
  }

  const chunks = chunk(ids, 10); // Firestore 'in' limit
  const snaps = await Promise.all(chunks.map(c =>
    definitionCollection('MeasureMoments')
      .where('CompagnyID', '==', client)
      .where('ResearchID', 'in', c)
      .orderBy('Position', 'asc')
      .get()
  ));

  const pos2title = momentTitlesByPosition(snaps.flatMap(s => s.docs.map(d => d.data())), ids);

  cache.set(key, pos2title);
  return pos2title;
};

export default getMomentTitlesByPosition;
